//---------------------
// Credit (개인신용 조회)
//---------------------
const creditRouter = [
  // ----------------------------
  // 유저 본인인증.
  // ----------------------------
  {
    path: "/credit/indiv",
    name: "credit-indiv-base",
    component: () =>
      import("../views/report/kcb/individual/IndivCreditBase.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request",
    name: "credit-indiv-request-base",
    component: () =>
      import(
        "../views/report/kcb/individual/request/IndivCreditRequestBase.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request/entry",
    name: "credit-indiv-request-entry",
    component: () =>
      import(
        "../views/report/kcb/individual/request/IndivCreditRequestEntry.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request/ask",
    name: "credit-indiv-request-ask",
    component: () =>
      import(
        "../views/report/kcb/individual/request/IndivCreditRequestAsk.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request/verify/tenant",
    name: "credit-indiv-request-verify-tenant",
    component: () =>
      import(
        "../views/report/kcb/individual/request/IndivCreditUserVerifyTenant.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request/verified/tenant",
    name: "credit-indiv-request-verified-tenant",
    component: () =>
      import(
        "../views/report/kcb/individual/request/IndivCreditUserVerifiedTenant.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  //typhoon guest
  {
    path: "/credit/indiv/request/typhoon/ask",
    name: "credit-indiv-request-typhoon-ask",
    component: () =>
      import(
        "../views/report/kcb/individual/request/typhoon/IndivCreditRequestTyphoonAsk.vue"
      ),
  },
  {
    path: "/credit/indiv/request/typhoon/verify/guest",
    name: "credit-indiv-request-typhoon-verify-guest",
    component: () =>
      import(
        "../views/report/kcb/individual/request/typhoon/IndivCreditUserVerifyTyphoonGuest.vue"
      ),
  },

  // ----------------------------
  // 요청 보내기
  // ----------------------------
  {
    path: "/credit/indiv/request/send/entry",
    name: "credit-indiv-request-send-entry",
    component: () =>
      import(
        "../views/report/kcb/individual/request/send/IndivCreditSendEntry.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request/send/owner",
    name: "credit-indiv-request-send-testing",
    component: () =>
      import(
        "../views/report/kcb/individual/request/send/IndivCreditSendToOwner.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request/send/realtor",
    name: "credit-indiv-request-send-to-realtor",
    component: () =>
      import(
        "../views/report/kcb/individual/request/send/IndivCreditSendToRealtor.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/request/send/complete",
    name: "credit-indiv-request-send-complete",
    component: () =>
      import(
        "../views/report/kcb/individual/request/send/IndivCreditSentComplete.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // ----------------------------
  // 동의 요청 받기 -- 공인중개사
  // ----------------------------
  {
    path: "/credit/indiv/agree/realtor",
    name: "credit-indiv-agree-realtor-base",
    component: () =>
      import(
        "../views/report/kcb/individual/request/receive/realtor/IndivCreditRealtorRecvBase.vue"
      ),
    // 공인중개사 경로는 로그인 없이 이용.
    // beforeEnter: (to, from, next) => {
    //   if (localStorage.naezip_to_ac_se) {
    //     next();
    //   } else {
    //     next("/");
    //   }
    // },
  },
  {
    path: "/credit/indiv/agree/realtor/complete",
    name: "credit-indiv-agree-realtor-complete",
    component: () =>
      import(
        "../views/report/kcb/individual/request/receive/realtor/IndivCreditRealtorRecvComplete.vue"
      ),
    // 공인중개사 경로는 로그인 없이 이용.
    // beforeEnter: (to, from, next) => {
    //   if (localStorage.naezip_to_ac_se) {
    //     next();
    //   } else {
    //     next("/");
    //   }
    // },
  },

  // ----------------------------
  // 동의 요청 받기 -- 집주인
  // ----------------------------
  {
    path: "/credit/indiv/agree/owner",
    name: "credit-indiv-agree-owner-base",
    component: () =>
      import(
        "../views/report/kcb/individual/request/receive/owner/IndivCreditOwnerRecvBase.vue"
      ),
    // 집주인 동의 요청 베이스 경로는 로그인 없이 이용 -- 다음 페이지부터는 로그인 필요.
    // beforeEnter: (to, from, next) => {
    //   if (localStorage.naezip_to_ac_se) {
    //     next();
    //   } else {
    //     next("/");
    //   }
    // },
  },
  {
    path: "/credit/indiv/agree/owner/login",
    name: "credit-indiv-agree-owner-login",
    component: () =>
      import(
        "../views/report/kcb/individual/request/receive/owner/IndivCreditOwnerRecvLogin.vue"
      ),
    // 집주인 동의 요청 로그인 경로는 로그인 없이 이용 -- 다음 페이지부터는 로그인 필요.
    // beforeEnter: (to, from, next) => {
    //   if (localStorage.naezip_to_ac_se) {
    //     next();
    //   } else {
    //     next("/");
    //   }
    // },
  },
  {
    path: "/credit/indiv/agree/owner/verify",
    name: "credit-indiv-agree-owner-verify",
    component: () =>
      import(
        "../views/report/kcb/individual/request/receive/owner/IndivCreditUserVerifyOwner.vue"
      ),
    // 집주인 로그인 필요.
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next(`/credit/indiv/agree/owner/login?oa=${to.query.oa}`);
      }
    },
  },
  {
    path: "/credit/indiv/agree/owner/verified",
    name: "credit-indiv-agree-owner-verified",
    component: () =>
      import(
        "../views/report/kcb/individual/request/receive/owner/IndivCreditUserVerifiedOwner.vue"
      ),
    // 집주인 로그인 필요.
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next(`/credit/indiv/agree/owner/login?oa=${to.query.oa}`);
      }
    },
  },

  // ----------------------------
  // 외부 리스트
  // ----------------------------
  {
    // 마이페이지에서 접근하는 외부 리스트.
    path: "/credit/indiv/list",
    name: "credit-indiv-external-list",
    component: () =>
      import(
        "../views/report/kcb/individual/result/list/IndivCreditListBase.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    // 외부 리스트에서 개인신용조회 리포트 신청하기 위해 주소 선택.
    path: "/credit/indiv/list/choose",
    name: "credit-indiv-external-list-choose",
    component: () =>
      import(
        "../views/report/kcb/individual/result/list/IndivCreditListChoose.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // ----------------------------
  // 결과 보기
  // ----------------------------
  {
    path: "/credit/indiv/result",
    name: "credit-indiv-result-base",
    component: () =>
      import(
        "../views/report/kcb/individual/result/IndivCreditQueryFinalBase.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/credit/indiv/result/list",
    name: "credit-indiv-result-list",
    component: () =>
      import(
        "../views/report/kcb/individual/result/IndivCreditQueryFinalList.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    // 임차인 결과 보기.
    path: "/credit/indiv/result/view",
    name: "credit-indiv-result-view",
    component: () =>
      import(
        "../views/report/kcb/individual/result/IndivCreditQueryFinalResult.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    // 집주인 결과 보기.
    path: "/credit/indiv/result/view/owner",
    name: "credit-indiv-result-view-owner",
    component: () =>
      import(
        "../views/report/kcb/individual/result/IndivCreditQueryFinalResultOwner.vue"
      ),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    // 게스트 결과 보기.
    path: "/credit/indiv/result/view/typhoon/guest",
    name: "credit-indiv-result-view-typhoon-guest",
    component: () =>
      import(
        "../views/report/kcb/individual/result/typhoon/IndivCreditQueryFinalResultTyphoonGuest.vue"
      ),
  },
];

export default creditRouter;
